import { useFetch } from "../lib/useFetch";
import { rm, pnlClass, ts } from "../lib/api";
import { PageHead, Panel, Stat, Spinner, Empty } from "../components/common";
import { EquityChart } from "./Home";

export default function Analytics() {
  const { data } = useFetch("/analytics", 60000);
  if (!data) return <Spinner />;
  const Kv = ({ obj }) => (Object.keys(obj).length ? Object.entries(obj).map(([k, v]) => <div key={k} className="mono flex justify-between text-xs"><span className="text-slate-600">{k}</span><span className={typeof v === "number" && v % 1 ? pnlClass(v) : ""}>{v}</span></div>) : <Empty>—</Empty>);
  return (
    <div data-testid="analytics-page">
      <PageHead title="Analytics" sub={data.sample_note} />
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
        <Stat label="Closed trades" value={data.closed_trades} /><Stat label="Win rate" value={data.win_rate != null ? `${data.win_rate}%` : "—"} /><Stat label="Profit factor" value={data.profit_factor ?? "—"} />
        <Stat label="Net realized" value={rm(data.net_realized)} tone={pnlClass(data.net_realized)} /><Stat label="Max drawdown" value={`${data.max_drawdown_pct}%`} />
        <Stat label="Avg gain" value={rm(data.avg_gain)} /><Stat label="Avg loss" value={rm(data.avg_loss)} /><Stat label="Fees total" value={rm(data.fees_total)} /><Stat label="FX effect" value={rm(data.fx_effect_total)} />
      </div>
      <Panel title="Equity" className="mt-3">{data.equity.length > 1 ? <EquityChart data={data.equity.map((x) => ({ x: ts(x.ts), y: x.equity }))} h={220} /> : <Empty>—</Empty>}</Panel>
      <div className="mt-3 grid gap-3 md:grid-cols-3">
        <Panel title="By exit reason"><Kv obj={data.by_exit_reason} /></Panel><Panel title="By symbol (RM)"><Kv obj={data.by_symbol} /></Panel><Panel title="By exchange (RM)"><Kv obj={data.by_exchange} /></Panel>
      </div>
    </div>
  );
}
